"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@rjsf/core");
// @ts-ignore
var antd_2 = require("@rjsf/antd");
var RevDateTimeToTimeStampPicker_1 = __importDefault(require("./CustomWidgets/RevDateTimeToTimeStampPicker"));
var RevArticleWidget_1 = __importDefault(require("./CustomWidgets/RevArticleWidget"));
var RevSingleImageUploader_1 = __importDefault(require("./CustomWidgets/RevSingleImageUploader"));
var RevLine_1 = __importDefault(require("./CustomWidgets/RevLine"));
var RevMultipleImageUploader_1 = __importDefault(require("./CustomFields/RevMultipleImageUploader"));
var RevRenameImage_1 = __importDefault(require("./CustomFields/RevRenameImage"));
var RevFilesUploader_1 = __importDefault(require("./CustomFields/RevFilesUploader"));
var RevRichTextField_1 = __importDefault(require("./CustomFields/RevRichTextField"));
var RevCodeArea_1 = __importDefault(require("./CustomWidgets/RevCodeArea"));
var RevWebDevEditor_1 = __importDefault(require("./CustomFields/RevWebDevEditor"));
var reconnect_js_1 = require("reconnect.js");
var RjsForm = core_1.withTheme(antd_2.Theme);
function Form(props) {
  var _this = this;
  var _a, _b;
  var schema = props.schema,
    uiSchema = props.uiSchema,
    errorSchema = props.errorSchema,
    instance = props.instance,
    _c = props.onSubmit,
    _onSubmit = _c === void 0 ? null : _c,
    _d = props.onChange,
    _onChange = _d === void 0 ? null : _d,
    renderCustomSubmitButton = props.renderCustomSubmitButton,
    renderCustomSection = props.renderCustomSection,
    formContext = props.formContext,
    formId = props.formId;
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var _e = react_1.default.useState(instance || {}),
    values = _e[0],
    setValues = _e[1];
  var _f = react_1.default.useState([]),
    errors = _f[0],
    setErrors = _f[1];
  var _g = react_1.default.useState({}),
    extValues = _g[0],
    setExtValues = _g[1];
  var submitBtnRef = react_1.default.useRef(null);
  var fileUploaderRefs = react_1.useRef({});
  react_1.default.useEffect(function () {
    setValues(instance || {});
  }, [instance, setValues]);
  var submitButton = react_1.default.useMemo(function () {
    if (renderCustomSubmitButton !== undefined) {
      if (typeof renderCustomSubmitButton === 'function') {
        return renderCustomSubmitButton({
          instance: instance,
          values: values,
          setValues: setValues,
          extValues: extValues,
          setExtValues: setExtValues
        }, submitBtnRef);
      }
      if (renderCustomSubmitButton === null) {
        return null;
      }
    }
    return react_1.default.createElement(antd_1.Button, {
      type: "primary",
      onClick: function onClick() {
        var _a;
        (_a = submitBtnRef.current) === null || _a === void 0 ? void 0 : _a.click();
      }
    }, "\u78BA\u8A8D");
  }, [extValues, instance, renderCustomSubmitButton, values]);
  var widgets = react_1.useMemo(function () {
    var _a, _b, _c;
    var customWidgets = {
      'rev-datetime-to-timestamp-picker': function revDatetimeToTimestampPicker(props) {
        return react_1.default.createElement(RevDateTimeToTimeStampPicker_1.default, __assign({}, props));
      },
      'rev-article-widget': function revArticleWidget(props) {
        return react_1.default.createElement(RevArticleWidget_1.default, __assign({}, props));
      },
      'rev-single-image-uploader': function revSingleImageUploader(props) {
        return react_1.default.createElement(RevSingleImageUploader_1.default, __assign({}, props));
      },
      'rev-line': function revLine(props) {
        return react_1.default.createElement(RevLine_1.default, __assign({}, props));
      },
      'rev-code-area': function revCodeArea(props) {
        return react_1.default.createElement(RevCodeArea_1.default, __assign({}, props));
      }
    };
    if ((_a = props.rjsfProps) === null || _a === void 0 ? void 0 : _a.widgets) {
      for (var name_1 in (_b = props.rjsfProps) === null || _b === void 0 ? void 0 : _b.widgets) {
        customWidgets[name_1] = (_c = props.rjsfProps) === null || _c === void 0 ? void 0 : _c.widgets[name_1];
      }
    }
    return customWidgets;
  }, [(_a = props.rjsfProps) === null || _a === void 0 ? void 0 : _a.widgets]);
  var fields = react_1.useMemo(function () {
    var _a, _b, _c;
    var customFields = {
      'rev-rename-image': function revRenameImage(props) {
        return react_1.default.createElement(RevRenameImage_1.default, __assign({}, props));
      },
      'rev-images': function revImages(props) {
        return react_1.default.createElement(RevMultipleImageUploader_1.default, __assign({}, props));
      },
      'rev-files': function revFiles(props) {
        var schema = props.schema,
          name = props.name;
        var schema_path = schema.schema_path;
        var key = schema_path || name;
        var _struct = key.split('.');
        var setRecursiveValue = function setRecursiveValue(struct_path, data) {
          var fieldName = struct_path === null || struct_path === void 0 ? void 0 : struct_path[0];
          if (fieldName) {
            var next = struct_path.slice(1, struct_path.length);
            data[fieldName] = {};
            return setRecursiveValue(next, data[fieldName]);
          } else {
            return data;
          }
        };
        var result = setRecursiveValue(_struct, fileUploaderRefs.current);
        return react_1.default.createElement(RevFilesUploader_1.default, __assign({
          refer: result
        }, props));
      },
      'rev-richtext': function revRichtext(props) {
        return react_1.default.createElement(RevRichTextField_1.default, __assign({}, props));
      },
      'rev-webdev': function revWebdev(props) {
        return react_1.default.createElement(RevWebDevEditor_1.default, __assign({}, props));
      }
    };
    if ((_a = props.rjsfProps) === null || _a === void 0 ? void 0 : _a.fields) {
      for (var name_2 in (_b = props.rjsfProps) === null || _b === void 0 ? void 0 : _b.fields) {
        customFields[name_2] = (_c = props.rjsfProps) === null || _c === void 0 ? void 0 : _c.fields[name_2];
      }
    }
    return customFields;
  }, [(_b = props.rjsfProps) === null || _b === void 0 ? void 0 : _b.fields]);
  var getTransformErrors = function getTransformErrors(errors) {
    var getRecursiveValue = function getRecursiveValue(levels, errorSchema) {
      var fieldName = levels === null || levels === void 0 ? void 0 : levels[0];
      if (fieldName) {
        var nextLevels = levels.slice(1, levels.length);
        return getRecursiveValue(nextLevels, errorSchema[fieldName]);
      } else {
        return errorSchema;
      }
    };
    return errors.map(function (e) {
      var levels = e.property.split('.').slice(1, e.property.split('.').length);
      var value = getRecursiveValue(levels, errorSchema);
      e.message = (value === null || value === void 0 ? void 0 : value[e.name]) || e.message;
      return e;
    });
  };
  var extraWrapperProps = {};
  if (formId) {
    extraWrapperProps.id = formId;
  }
  return react_1.default.createElement(Wrapper, __assign({}, extraWrapperProps), renderCustomSection && renderCustomSection({
    position: 'top',
    instance: instance,
    values: values,
    setValues: setValues,
    extValues: extValues,
    setExtValues: setExtValues,
    errors: errors,
    formSpec: {
      schema: schema,
      uiSchema: uiSchema,
      errorSchema: errorSchema
    }
  }), react_1.default.createElement(RjsForm, {
    className: "rev-rjsform",
    schema: schema,
    uiSchema: uiSchema,
    showErrorList: false,
    transformErrors: errorSchema ? getTransformErrors : function (errors) {
      return errors;
    },
    widgets: widgets,
    fields: fields,
    formData: values,
    onChange: function onChange(_a) {
      var formData = _a.formData;
      setValues(formData);
      if (_onChange) {
        _onChange(formData);
      }
    },
    onSubmit: function onSubmit(_a) {
      var formData = _a.formData;
      return __awaiter(_this, void 0, void 0, function () {
        var nextFormData, _deepFirstSearch_;
        var _this = this;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              setErrors([]);
              AppActions.setLoading(true);
              nextFormData = __assign({}, formData);
              if (!(Object.keys(fileUploaderRefs.current).length > 0)) return [3 /*break*/, 2];
              _deepFirstSearch_ = function _deepFirstSearch_1(parentStack, data) {
                return __awaiter(_this, void 0, void 0, function () {
                  var _i, _a, childStackKeyValuePair, _b, key, value, _c, _d;
                  return __generator(this, function (_e) {
                    switch (_e.label) {
                      case 0:
                        _i = 0, _a = Object.entries(parentStack);
                        _e.label = 1;
                      case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 6];
                        childStackKeyValuePair = _a[_i];
                        _b = childStackKeyValuePair, key = _b[0], value = _b[1];
                        if (!value.hasOwnProperty('onUpload')) return [3 /*break*/, 3];
                        _c = data;
                        _d = key;
                        return [4 /*yield*/, value.onUpload()];
                      case 2:
                        _c[_d] = _e.sent();
                        return [3 /*break*/, 5];
                      case 3:
                        return [4 /*yield*/, _deepFirstSearch_(value, data[key])];
                      case 4:
                        _e.sent();
                        _e.label = 5;
                      case 5:
                        _i++;
                        return [3 /*break*/, 1];
                      case 6:
                        return [2 /*return*/];
                    }
                  });
                });
              };

              return [4 /*yield*/, _deepFirstSearch_(fileUploaderRefs.current, nextFormData)];
            case 1:
              _b.sent();
              setValues(function (prev) {
                return __assign(__assign({}, prev), nextFormData);
              });
              _onSubmit(nextFormData, extValues, setValues);
              return [3 /*break*/, 3];
            case 2:
              _onSubmit(formData, extValues, setValues);
              _b.label = 3;
            case 3:
              return [2 /*return*/];
          }
        });
      });
    },

    onError: function onError(_errors) {
      console.log(_errors);
      setErrors(_errors);
    },
    formContext: formContext
  }, renderCustomSection && renderCustomSection({
    position: 'bottom',
    instance: instance,
    values: values,
    setValues: setValues,
    extValues: extValues,
    setExtValues: setExtValues,
    errors: errors,
    formSpec: {
      schema: schema,
      uiSchema: uiSchema,
      errorSchema: errorSchema
    }
  }), react_1.default.createElement("div", {
    className: "submit-buttons-bar"
  }, submitButton, react_1.default.createElement("button", {
    type: "submit",
    ref: submitBtnRef
  })), renderCustomSection && renderCustomSection({
    position: 'below-submit',
    instance: instance,
    values: values,
    setValues: setValues,
    extValues: extValues,
    setExtValues: setExtValues,
    errors: errors,
    formSpec: {
      schema: schema,
      uiSchema: uiSchema,
      errorSchema: errorSchema
    }
  })), renderCustomSection && renderCustomSection({
    position: 'below-form',
    instance: instance,
    values: values,
    setValues: setValues,
    extValues: extValues,
    setExtValues: setExtValues,
    errors: errors,
    formSpec: {
      schema: schema,
      uiSchema: uiSchema,
      errorSchema: errorSchema
    }
  }));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 800px;\n  & .submit-buttons-bar {\n    display: flex;\n    justify-content: flex-end;\n    & button[type='submit'] {\n      display: none;\n    }\n  }\n"], ["\n  max-width: 800px;\n  & .submit-buttons-bar {\n    display: flex;\n    justify-content: flex-end;\n    & button[type='submit'] {\n      display: none;\n    }\n  }\n"])));
exports.default = Form;
var templateObject_1;